import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { MoneyInput, parseMoney } from "@/components/MoneyInput";

const NEW = "__new";

export const itemError = (i, block) => {
  const name = (i.name || "").trim();
  const cat = (i.cat || block || "").trim();
  if (!name) return "Informe o nome do produto.";
  if (name.length > 120) return "O nome pode ter até 120 letras.";
  if (!(i.price >= 0) || i.price > 100000) return "Preço inválido.";
  if ((i.description || "").length > 500) return "A descrição pode ter até 500 letras.";
  if (!cat || cat.length > 60) return "Escolha ou digite a categoria.";
  return "";
};

function CategoryPicker({ value, found, existing, onChange, testid }) {
  const all = [...found, ...existing];
  const match = all.find((o) => o.toLowerCase() === value.trim().toLowerCase());
  const [typing, setTyping] = useState(!match);
  const pick = (v) => { setTyping(v === NEW); onChange(v === NEW ? "" : v); };
  return (
    <div className="flex flex-col gap-2 sm:flex-row">
      <select value={typing ? NEW : match} onChange={(e) => pick(e.target.value)} className="h-9 rounded-md border bg-transparent px-2 text-sm sm:w-1/2" data-testid={`${testid}-select`}>
        {found.length > 0 && <optgroup label="Encontradas no cardápio">{found.map((o) => <option key={o} value={o}>{o}</option>)}</optgroup>}
        {existing.length > 0 && <optgroup label="Já cadastradas no sistema">{existing.map((o) => <option key={o} value={o}>{o}</option>)}</optgroup>}
        <option value={NEW}>+ Nova categoria...</option>
      </select>
      {typing && <Input autoFocus value={value} onChange={(e) => onChange(e.target.value)} placeholder="Nome da nova categoria" maxLength={60} className="h-9" data-testid={`${testid}-new`} />}
    </div>
  );
}

const Field = ({ label, children }) => <label className="block space-y-1"><span className="text-xs font-medium text-muted-foreground">{label}</span>{children}</label>;

export function ImportItemEdit({ item, block, found, existing, onSave, onCancel }) {
  const [d, setD] = useState({ name: item.name, price: Number(item.price || 0).toFixed(2).replace(".", ","), description: item.description || "", cat: item.cat || block });
  const set = (k) => (v) => setD((x) => ({ ...x, [k]: v }));
  const cat = d.cat.trim();
  const patch = { name: d.name.trim(), price: parseMoney(d.price), description: d.description.trim(), cat: cat.toLowerCase() === block.trim().toLowerCase() ? null : cat };
  const err = itemError(patch, block);
  const id = `menu-import-edit-${item.key}`;
  return (
    <div className="space-y-3 bg-muted/30 p-3" data-testid={id}>
      <div className="grid gap-3 sm:grid-cols-[1fr_150px]">
        <Field label="Nome"><Input value={d.name} onChange={(e) => set("name")(e.target.value)} maxLength={120} className="h-9" data-testid={`${id}-name`} /></Field>
        <Field label="Preço (R$)"><MoneyInput value={d.price} onChange={set("price")} className="h-9" data-testid={`${id}-price`} /></Field>
      </div>
      <Field label="Descrição"><Textarea rows={2} value={d.description} onChange={(e) => set("description")(e.target.value)} maxLength={500} data-testid={`${id}-description`} /></Field>
      <Field label="Categoria"><CategoryPicker value={d.cat} found={found} existing={existing} onChange={set("cat")} testid={`${id}-category`} /></Field>
      {err && <p className="text-xs text-red-500" data-testid={`${id}-error`}>{err}</p>}
      <div className="flex justify-end gap-2">
        <Button variant="ghost" size="sm" onClick={onCancel} data-testid={`${id}-cancel`}>Cancelar</Button>
        <Button size="sm" disabled={!!err} onClick={() => onSave(patch)} data-testid={`${id}-save`}>Salvar</Button>
      </div>
    </div>
  );
}
